{
  "SIGNUP PAGE": "====================",
  "Введите_имя": "Введите имя",
  "Введите_email": "Введите e-mail",
  "Введите_пароль": "Введите пароль",
  "Пароль_не_менее": "Пароль не менее 8 символов",
  "Повторный_пароль_не_совпадает": "Повторный пароль не совпадает",
  "Ознакомьтесь_с_Политикой_и_Офертой": "Ознакомьтесь с Политикой и Офертой",
  "Email_не_валидный": "E-mail не действительный",
  "Email_уже_используется": "E-mail уже используется",
  "Некорректный_рефкод": "Некорректный код партнёра",
  "Регистрация": "Регистрация",
  "Войдите": "Войдите",
  "Есть_аккаунт": "Есть аккаунт",
  "Ваше_имя": "Ваше имя",
  "Ваш_email": "Ваш e-mail",
  "Ваш_пароль": "Ваш пароль",
  "Подтвердите_пароль": "Подтвердите пароль",
  "Код_партнера": "Код партнера (необязательно)",
  "Зарегистрироваться": "Зарегистрироваться",
  "с": "с",
  "Публичной_офертой": "Публичной офертой",
  "и": "и",
  "Политикой_конфиденциальности": "Политикой конфиденциальности",
  "ознакомлен": "ознакомлен",
  "На_ваш_e_mail": "На ваш e-mail",
  "был_отправлен_код": "был отправлен код для подтверждения регистрации.",
  "Пожалуйста_нажмите_кнопку": "Пожалуйста, нажмите кнопку 'Подтвердить регистрацию' в письме.",
  "Вернуться_ко_входу": "Вернуться ко Входу",

  "LOGIN PAGE": "====================",
  "Логин_или_пароль_не_найдены": "Логин или пароль не найдены",
  "Email_не_верифицирован": "E-mail не верифицирован",
  "Вход": "Вход",
  "Нет_аккаунта": "Нет аккаунта",
  "Войти": "Войти",
  "Забыли_пароль": "Забыли пароль",

  "FORGOT PASSWORD PAGE": "====================",
  "Успешно": "Успешно",
  "Письмо_с_инструкцией": "Письмо с инструкцией по восстановлению пароля было выслано на вашу почту",
  "Перейти_ко_входу": "Перейти ко входу",
  "Восстановление_пароля": "Восстановление\nпароля",
  "Восстановить": "Восстановить",
  "Я_вспомнил_пароль": "Я вспомнил пароль, вернуться",
  "Введите_код": "Введите код",
  "Формат_поля_6_цифр": "Формат поля: 6 цифр",
  "Почта_уже_используется": "Почта уже используется",
  "Код_недействителен": "Код недействителен или просрочен",
  "Почта_не_найдена": "Почта не найдена",

  "PASSWORD RESET PAGE": "====================",
  "Укажите_новый_пароль": "Укажите новый пароль",
  "Подтверждение": "Подтверждение",
  "Данные_успешно_обновлены": "Данные успешно обновлены",
  "Можно_выполнить_вход": "Можно выполнить вход",
  "Смена_пароля": "Смена\nпароля",
  "Новый_пароль": "Новый пароль",
  "Обновить_пароль": "Обновить пароль",

  "CALENDAR": "====================",
  "Выберите_пресет": "Выберите пресет",
  "За_все_время": "За все время",
  "Неделя": "Неделя",
  "Месяц": "Месяц",
  "Квартал": "Квартал",
  "Год": "Год",

  "Для_отображения_своего_периода": "Для отображения своего периода выполните следующие шаги",
  "Выделите_начальную_дату": "Выделите начальную дату",
  "Укажите_конечную_дату": "Укажите конечную дату",
  "Фильтр_автоматически_применится_и_отобразит": "Фильтр автоматически применится и отобразит данные за выбранный период",
  "Если_нужен_период_более": "Если нужен период более одного месяца",
  "Прокрутите_календарь": "Прокрутите календарь до нужного месяца",
  "Укажите_начальную_дату": "Укажите начальную дату",
  "Прокрутите_календарь_до_необходимого": "Прокрутите календарь до необходимого месяца и укажите конечную дату",
  "Фильтр_автоматически_применится": "Фильтр автоматически применится",

  "Common Periods": "====================",
  "Воскресенье": "Воскресенье",
  "Понедельник": "Понедельник",
  "Вторник": "Вторник",
  "Среда": "Среда",
  "Четверг": "Четверг",
  "Пятница": "Пятница",
  "Суббота": "Суббота",
  "месяц": "месяц",
  "месяца": "месяца",
  "месяцев": "месяцев",

  "INPUT": "====================",
  "Формат_данных": "Формат данных",
  "Введите_корректный_email": "Введите корректный e-mail",
  "Введите_корректный_номер_счета": "Введите корректный номер счета",

  "FAQ": "====================",
  "faq": "Часто задаваемые вопросы",

  "Footer": "====================",
  "Публичная_оферта": "Публичная оферта",
  "Политика_конфиденциальности": "Политика конфиденциальности",

  "Header": "====================",
  "Выйти": "Выйти",
  "Тема": "Тема",
  "Язык": "Язык",
  "Онлайн_мониторинг": "Онлайн мониторинг",
  "Партнерка": "Партнерка",
  "Балансовые_операции": "Балансовые операции",
  "Поддержка": "Поддержка",

  "No data": "====================",
  "Список_на_данный_момент_пуст": "Список на данный момент пуст",
  "нет_данных": "нет данных",

  "Pagination": "====================",
  "Всего_найдено": "Всего найдено",

  "Common Payment methods": "====================",
  "Метод_оплаты": "Метод оплаты",
  "Банковская_карта": "Банковская карта",
  "Электронный_кошелек": "Электронный кошелек",
  "Криптокошелек": "Крипто-кошелек",
  "Баланс_ЛК": "Баланс ЛК",
  "Укажите_метод_оплаты": "Укажите метод оплаты",

  "Payment Balance": "====================",
  "Недостаточно_средств": "Недостаточно средств для оплаты",
  "Оплата_успешно": "Оплата прошла успешно",
  "Идентификатор_транзакции_уже_используется": "Идентификатор транзакции уже используется",
  "Оплата_с_баланса": "Оплата с баланса",
  "Сумма_платежа": "Сумма платежа",
  "Назад": "Назад",
  "Оплатить": "Оплатить",

  "Payment Bank": "====================",
  "Номер_нашей_карты_скопирован": "Номер нашей карты скопирован",
  "Ваш_email_скопирован": "Ваш e-mail скопирован",
  "Укажите_Вашу_карту": "Укажите Вашу карту",
  "Нет_сигнатуры": "Нет сигнатуры для завершения оплаты",
  "Платеж_в_обработке": "Платеж в обработке",
  "Оплата_с_банковской_карты": "Оплата с банковской карты",
  "Комиссия": "Комиссия",
  "Комиссия_включена": "Комиссия включена",
  "Платежные_системы": "Платежные системы",
  "Наша": "Наша",
  "карта": "карта",
  "Введите_вашу_карту": "Введите вашу карту",
  "Подтвердить_оплату": "Подтвердить оплату",
  "ВНИМАНИЕ_После_отправки": "ВНИМАНИЕ! После отправки средств нажмите СООБЩИТЬ ОБ ОПЛАТЕ. СНАЧАЛА ОТПРАВЛЯЕТЕ ДЕНЬГИ, ПОТОМ НАЖИМАЙТЕ НА КНОПКУ.",
  "Данная_платежная_система": "Данная платежная система имеет ограничение на минимальную сумму платежа",
  "Пожалуйста_используйте_другой_метод": "Пожалуйста, используйте другой метод оплаты.",

  "Payment Crypto": "====================",
  "Адрес_нашего_кошелька_скопирован": "Адрес нашего кошелька скопирован",
  "Укажите_ваш_кошелек": "Укажите ваш кошелек",
  "Укажите_TXID": "Укажите TXID",
  "Оплата_криптовалютой": "Оплата криптовалютой",
  "адрес_кошелька_для_оплаты": "адрес кошелька для оплаты",
  "Отсканируйте_код_кошелька": "Отсканируйте QR код кошелька",
  "Введите_ваш_кошелек": "Введите ваш кошелек",
  "TXID_транзакции": "TXID транзакции",
  "Идентификатор_транзакции": "Идентификатор транзакции (TxID), или хеш транзакции, – это уникальная для каждой транзакции последовательность символов, проверенная и добавленная в блокчейн. Другими словами, TxID – это идентификационный номер, который маркирует каждую транзакцию в блокчейне. Идентификатор транзакции(TxID) может выглядеть например так: b20sefa5*********922f1ae884",
  "Для_оплаты_заказа_переведите": "Для оплаты заказа переведите средства на адрес кошелька, указанный в строке 'Адрес кошелька для оплаты'. После перевода нажмите кнопку 'Подтвердить оплату'",

  "Payment Wallet": "====================",
  "Оплата_электронным_кошельком": "Оплата электронным кошельком",
  "Наш": "Наш",
  "кошелек": "кошелек",

  "VPS PAGE": "====================",
  "Приветствуем": "Приветствуем",

  "VPS PAGE Rates": "====================",
  "Укажите_период": "Укажите период",
  "Введите_промокод": "Введите промокод",
  "Процессор": "Процессор",
  "Память": "Память",
  "Диск": "Диск",
  "ОС": "ОС",
  "Терминалы": "Терминалы",
  "Трафик": "Трафик",
  "безлимитный": "безлимитный",
  "мес": "мес.",
  "Срок_аренды": "Срок аренды",
  "Промокод": "Промокод",
  "Заказать": "Заказать",
  "скидка": "скидка",

  "Укажите_источник": "Укажите источник",
  "Заявка_на_Тестовый": "Заявка на Тестовый сервер на рассмотрении",
  "Тестовый_сервер_уже_заказан": "Тестовый сервер уже заказан",
  "Тестовый_сервер": "Тестовый сервер",
  "дня": "дня",
  "Откуда_узнали_о_нас": "Откуда узнали о нас",

  "VPS PAGE Rates = Modal Buy": "====================",
  "Введите_сумму": "Введите сумму",
  "Подтверждение_действия": "Подтверждение действия",
  "Если_вы_хотите_арендовать_новый": "Если вы хотите арендовать новый VPS, нажмите кнопку 'Далее'. Если же вы планируете продлить аренду своего текущего VPS, закройте данное окно, перейдите в раздел 'VPS серверы' и нажмите кнопку 'Продлить'",
  "Оплата_тарифа": "Оплата тарифа",

  "Заявка_на_тестовый_доступ": "Заявка на тестовый доступ к серверу успешно отправлена. По регламенту заявки обрабатываются в течение рабочего дня. По результату Вам придет уведомление на e-mail.",

  "VPS PAGE Servers": "====================",
  "серверы": "серверы",

  "Поиск_по_ID": "Поиск по ID",

  "Все": "Все",
  "Активный": "Активный",
  "Заблокирован": "Заблокирован",
  "Отозван": "Отозван",

  "VPS PAGE Servers Table Header": "====================",
  "Тариф": "Тариф",
  "Комментарий": "Комментарий",
  "Данные_для_входа": "Данные для входа",
  "Выдан": "Выдан",
  "Оплачен_до": "Оплачен до",
  "Продление": "Продление",
  "Автопродление": "Автопродление",
  "Автопродление_позволит": "Автопродление позволит вам автоматически оплачивать продление аренды VPS с баланса личного кабинета. Для активации данной функции убедитесь, что баланс личного кабинета пополнен на необходимую сумму.",
  "Статус": "Статус",

  "VPS PAGE Servers Table Content": "====================",
  "Функция_автопродления_выключена": "Функция автопродления выключена",
  "Функция_автопродления_подключена": "Функция автопродления подключена",
  "Показать": "Показать",
  "данные_для_входа": "данные для входа",
  "Продлить": "Продлить",

  "Принять": "Принять",
  "Отменить": "Отменить",

  "VPS PAGE Servers Modal Upgrade": "====================",
  "Выберите_тариф_для_апгрейда": "Выберите тариф для апгрейда",
  "Укажите_дату_проведения_апгрейда": "Укажите дату проведения апгрейда",
  "Заявка_на_апгрейд_сервера_отправлена": "Заявка на апгрейд сервера отправлена",
  "Заявка_на_апгрейд_сервера_уже_принята": "Заявка на апгрейд сервера уже принята и обрабатывается",
  "Поздравляем": "Поздравляем",
  "Заявка_успешно_принята": "Заявка успешно принята, апгрейд будет произведен в указанный в заявке день.",
  "Отлично": "Отлично",
  "Смена_тарифа": "Смена тарифа",
  "Текущий_тариф": "Текущий тариф",
  "Изменить_на": "Изменить на",
  "Выбрать_дату": "Выбрать дату",
  "Подать_заявку": "Подать заявку",
  "Внимание_Ваш_сервер": "Внимание! Ваш сервер будет отключен на срок до 1 часа. При апгрейде в некоторых случаях изменяются данные для входа (IP:порт, логин и пароль). Все данные сохраняются, аренда пересчитывается по новому тарифу.",
  "Вы_выбрали_проведение_апгрейда_в": "Вы выбрали проведение апгрейда в торговый день! При апгрейде потребуется отключение сервера на срок до 1 часа!",

  "VPS PAGE Servers Modal Prolongate": "====================",
  "Выберите_период": "Выберите период",
  "Продление_сервера": "Продление сервера",
  "К_оплате": "К оплате",
  "Срок_продления": "Срок продления",
  "Далее": "Далее",

  "VPS PAGE Servers Modal Credentials": "====================",
  "IP_скопирован": "IP скопирован",
  "Логин_скопирован": "Логин скопирован",
  "Пароль_скопирован": "Пароль скопирован",
  "Данные_при_входе": "Данные при входе",
  "IP_адрес": "IP адрес",
  "Логин": "Логин",
  "Пароль": "Пароль",
  "Скачать_файл_для_входа_на_VPS": "Скачать файл для входа на VPS",
  "Воспользуйтесь_удобной_функцией": "Воспользуйтесь удобной функцией быстрого доступа к VPS. Нажмите на кнопку выше, запустите скачанный файл и укажите пароль от VPS.",

  "VPS PAGE Servers Modal Control": "====================",
  "Запрос_на_включение": "Запрос на включение сервера отправлен успешно",
  "Сервер_включен": "Сервер включен",
  "Сервер_отозван": "Сервер отозван",
  "Предыдущий_запрос": "Предыдущий запрос еще обрабатывается. Время обработки 1-2 минуты.",
  "Некорректные_данные": "Некорректные данные - обратитесь в поддержку",
  "Запрос_на_выключение": "Запрос на выключение сервера отправлен успешно",
  "Сервер_выключен": "Сервер выключен",
  "Запрос_на_перезагрузку": "Запрос на перезагрузку сервера отправлен успешно",
  "Включить": "Включить",
  "Отключить": "Отключить",
  "Перезагрузить": "Перезагрузить",

  "MONITORING PAGE": "====================",
  "Подписка": "Подписка",
  "Мои_счета": "Мои счета",
  "Гайд": "Гайд",

  "MONITORING SUBSCRIPTION PAGE": "====================",
  "Бесплатное_предложение_недоступно": "Бесплатное предложение недоступно",
  "Код_активации_успешно_скопирован": "Код активации успешно скопирован",
  "Подписка_FREE_активирована": "Подписка FREE активирована",
  "Мониторинг": "Мониторинг",
  "Конструктор_отчетов": "Конструктор отчетов",
  "Расширенные_настройки": "Расширенные настройки",
  "счет_на_мониторинге": "счет на мониторинге",
  "Как_пользоваться_мониторингом": "Как пользоваться мониторингом",
  "Кол_во_счетов": "Кол-во счетов",
  "Кол_во_месяцев": "Кол-во месяцев",
  "Активировать": "Активировать",
  "Количество_счетов_от_1_до_50": "Количество счетов от 1 до 50",
  "Количество_месяцев_от_1_до_12": "Количество месяцев от 1 до 12",
  "Платная_подписка_уже_активирована": "Платная подписка уже активирована",
  "Введите_количество_счетов": "Введите количество счетов",
  "Введите_количество_месяцев": "Введите количество месяцев",
  "Оплата_подписки": "Оплата подписки",
  "Продление_подписки": "Продление подписки",
  "HTML_код_успешно_скопирован": "HTML-код успешно скопирован",
  "BB_код_успешно_скопирован": "BB-код успешно скопирован",
  "Ссылка_успешно_скопирована": "Ссылка успешно скопирована",
  "Поделиться_мониторингом": "Поделиться мониторингом",
  "HTML_код": "HTML-код",
  "BB_код": "BB-код",
  "Ссылка": "Ссылка",
  "Виджет": "Виджет",

  "MONITORING SUBSCRIPTION=Advisor": "====================",
  "Cкачать_советник": "Cкачать советник",
  "Скачать_для": "Скачать для",
  "версия": "версия",

  "MONITORING SUBSCRIPTION=Table": "====================",
  "Подписки": "Подписки",
  "Доступно_счетов": "Доступно счетов",
  "Дата_активации": "Дата активации",
  "Автопродление_позволит_вам": "Автопродление позволит вам автоматически оплачивать продление подписки на мониторинг с баланса личного кабинета. Для активации данной функции убедитесь, что баланс личного кабинета пополнен на необходимую сумму.",
  "Добавить_кол_во_счетов": "Добавить кол-во счетов",
  "Добавить_счёт": "Добавить счёт",
  "Приобрести": "Приобрести",
  "Введите_количество_добавляемых_счетов": "Введите количество добавляемых счетов'",
  "Добавить_счета": "Добавить счета",
  "Введите_кол_во_счетов": "Введите кол-во счетов",
  "Внимание_Добавление_счетов": "ВНИМАНИЕ! здесь должно быть понятное объяснение клиенту. как он будет оплачивать дополнительный счет и прочая полезная информация.",

  "MONITORING ACCOUNTS PAGE": "====================",
  "Создать_мониторинг": "Создать мониторинг",
  "Подписка_не_позволяет_добавлять": "Подписка не позволяет добавлять мониторинг",
  "Статус_подписки_не_позволяет_добавлять": "Статус подписки не позволяет добавлять мониторинг",
  "Добавьте_счета_в_подписку_для_подключения": "Добавьте счета в подписку для подключения дополнительно мониторинга",
  "название": "название",
  "просадка": "просадка",
  "прибыль": "прибыль",
  "баланс": "баланс",
  "сделки": "сделки",
  "просмотры": "просмотры",
  "управление": "управление",
  "инфо_прибыль_процент": "Общая прибыль в процентах, по счету за все время работы онлайн мониторинга",
  "инфо_прибыль_валюта": "Общая прибыль в валюте, по счету за все время работы онлайн мониторинга",
  "инфо_просадка": "Просадка в процентах по торговому счету в данный момент",
  "инфо_баланс": "Баланс торгового счета в валюте на данный момент",
  "инфо_средства": "Cредства счета в валюте с учетом открытых сделок",
  "инфо_сделки": "Количество закрытых сделок",
  "инфо_просмотры": "Количество просмотров данного онлайн мониторинга",
  "Потеряна_связь_с_терминалом": "Потеряна связь с терминалом",
  "Вы_действительно_хотите_удалить_мониторинг": "Вы действительно хотите удалить мониторинг",
  "Удалить": "Удалить",
  "Мониторинг_удален_успешно": "Мониторинг удален успешно",
  "Ошибка_при_удалении_Мониторинга": "Ошибка при удалении Мониторинга",
  "Нужно_продлить_подписку": "Нужно продлить подписку",
  "Мониторинг_успешно_создан": "Мониторинг успешно создан",
  "Ошибка_при_создании_Мониторинга": "Ошибка при создании Мониторинга",
  "Код_активации_скопирован": "Код активации скопирован",
  "Введите_номер_счета": "Введите номер счета",
  "Введите_название_мониторинга": "Введите название мониторинга",
  "Сгенерируйте_код_активации": "Сгенерируйте код активации",

  "MONITORING ACCOUNT PAGE": "====================",
  "Статистика": "Статистика",
  "Настройки": "Настройки",
  "Макс_баланс": "Максимальный баланс",
  "Пополнения": "Пополнения",

  "MONITORING ACCOUNT STATISTICS PAGE": "====================",
  "Текущие_данные": "Текущие данные",
  "Инфо_Текущие_данные": "Данные по счету за всё время",
  "ежедневно": "ежедневно",
  "ежемесячно": "ежемесячно",
  "макс_просадка": "макс просадка",
  "средства": "средства",
  "свободная_маржа": "свободная маржа",
  "История_операций": "История операций",
  "Кол_во_сделок": "Кол-во сделок",

  "MONITORING ACCOUNT SETTINGS PAGE": "====================",
  "Общие": "Общие",
  "Номер_счета": "Номер счета",
  "Название_мониторинга": "Название мониторинга",
  "Код_активации": "Код активации",
  "Сгенерировать": "Сгенерировать",
  "Уведомления_и_отчеты_о_работе": "Уведомления и отчеты о работе онлайн мониторинга Вы сможете получать после того, как подключите Telegram Bot для мониторингов.",
  "Сохранить_изменения": "Сохранить изменения",
  "Настройки_мониторинга_обновлены_успешно": "Настройки мониторинга обновлены успешно",
  "Ошибка_при_изменении_настроек_мониторинга": "Ошибка при изменении настроек мониторинга",
  "Ошибка_при_отключении_Telegram_bot": "Ошибка при отключении Telegram bot",

  "Отчеты": "Отчеты",
  "Настройки_отчетов_обновлены_успешно": "Настройки отчетов обновлены успешно",
  "Ошибка_при_изменении_настроек_отчетов": "Ошибка при изменении настроек отчетов",
  "Количество": "Количество",
  "ордеров": "ордеров",
  "ежедневный_отчет": "ежедневный отчет",
  "еженедельный_отчет": "еженедельный отчет",
  "ежемесячный_отчет": "ежемесячный отчет",

  "Уведомления": "Уведомления",
  "Настройки_уведомлений_обновлены_успешно": "Настройки уведомлений обновлены успешно",
  "Ошибка_при_изменении_настроек_уведомлений": "Ошибка при изменении настроек уведомлений",
  "Достижение_просадки_в_деньгах": "Достижение просадки в деньгах",
  "Достижение_просадки_в_процентах": "Достижение просадки в процентах",
  "Контроль_кредитного_плеча_1_к": "Контроль кредитного плеча 1 к",
  "Достижение_уровня_безубытка": "Достижение уровня безубытка",
  "Открытие_ордера": "Открытие ордера",
  "Закрытие_ордера": "Закрытие ордера",
  "сетки_ордера": "сетки ордера",
  "Связь_с_терминалом": "Связь с терминалом метатрейдер",
  "Введите_значение": "Введите значение",
  "Введите_шаг": "Введите шаг",
  "Значение": "Значение",
  "Шаг": "Шаг",

  "PARTNERS PAGE": "====================",
  "Партнерская_программа": "Партнерская программа",
  "Всего_клиентов": "Всего клиентов",
  "Клиенты_первого_уровня": "Клиенты первого уровня",
  "Клиенты_второго_уровня": "Клиенты второго уровня",
  "Клиенты_третьего_уровня": "Клиенты третьего уровня",

  "Парнерская_ссылка_скопирована": "Партнерская ссылка скопирована!",
  "Парнерский_код_скопирован": "Партнерский код скопирован!",
  "Вывод": "Вывод",
  "Партнерское_вознаграждение": "Партнерское вознаграждение",
  "Партнерское_вознаграждение_info": "Партнерское вознаграждение - процент от суммы покупки привлеченного вами клиента, который вы будете получать пожизненно за каждую покупку или продление услуги привлеченным Вами клиентом",
  "Ваша_партнерская_ссылка": "Ваша партнерская ссылка",
  "Если_пользователь_кликнет": "Если пользователь перейдет по вашей партнерской ссылке и арендует VPS, вы получите процент от суммы его платежа, а также от всех последующих платежей. Сумма партнерского вознаграждение отображается в верхнем левом блоке партнерского раздела, пункт 'Партнерское вознаграждение'.",
  "Ваш_партнерский_код": "Ваш партнерский код",
  "Партнерский_код_это": "Партнерский код является альтернативой партнерской ссылке. Передайте свой партнерский код пользователю, при регистрации он должен будет ввести его в соответствующее поле формы регистрации, что обеспечит 100% попадание клиента в вашу партнерскую группу.",

  "PARTNERS Withdraw Modal": "====================",
  "Выберите_метод_вывода": "Выберите метод вывода",
  "Введите_кошелек": "Введите кошелек",
  "Минимальная_сумма_вывода": "Минимальная сумма для вывода средств",
  "Недостаточно_средств_на_балансе": "Недостаточно средств на партнерском балансе",
  "Ошибка_при_выводе": "Ошибка при заявке на вывод",
  "Вывод_партнерского_вознаграждения": "Вывод партнерского вознаграждения",
  "Метод_вывода": "Метод вывода",
  "Кошелек": "Кошелек",
  "Сумма": "Сумма",
  "Создать": "Создать",
  "Минимальная_сумма_для_вывода": "Минимальная сумма для вывода партнерского вознаграждения составляет",
  "Заявка_на_вывод_обрабатывается": "Заявка на вывод обрабатывается в течение 5 рабочих дней.",
  "Заявка_на_вывод_создана": "Заявка на вывод партнерского вознаграждения создана. Как только заявка будет обработана, Вам на почту придет уведомление. Пожалуйста, ожидайте.",
  "Внимание": "Внимание",
  "Подача_новой_заявки": "Подача новой заявки на вывод партнерского вознаграждения будет доступна после обработки вашей предыдущей заявки",

  "PARTNERS Statistics Servers": "",
  "Статистика_по_аренде_VPS": "Статистика по аренде VPS",
  "Выбор_периода": "Выбор периода",
  "Клики": "Клики",
  "Клики_info": "Общее количество переходов по вашей партнерской ссылке за выбранный период",
  "Регистрации": "Регистрации",
  "Регистрации_info": "Количество клиентов зарегистрировавшихся по вашей партнерской ссылке за выбранный период",
  "Арендованные_VPS": "Арендовано VPS",
  "Арендованные_VPS_info": "Количество купленных серверов клиентами из вашей партнерской группы за выбранный период",
  "Продленные_VPS": "Продленные VPS",
  "Продленные_VPS_info": "Количество платежей на продление серверов клиентами из вашей партнерской группы за выбранный период",
  "Вознаграждение": "Вознаграждение",
  "Вознаграждение_VPS_info": "Общая сумма полученного партнерского вознаграждения за выбранный период",
  "Конверсия": "Конверсия",
  "Конверсия_info": "Конверсия - это отношение кликов пользователей по партнерской ссылке, которые купили сервер, к общему числу кликов  за выбранный период",
  "за_продажу": "за продажу",
  "за_продление": "за продление",
  "Всего": "Всего",

  "PARTNERS Statistics Clients": "",
  "Статистика_по_клиентам": "Статистика по клиентам",
  "Статистика_по_клиентам_info": "Данные статистики партнерских вознаграждений по уровням",
  "Процент": "Процент",
  "Процент_info": "Процент партнерского вознаграждения соответствующий уровню",
  "Клиентов": "Клиентов",
  "Оборот": "Оборот",
  "Оборот_info": "Общее количество покупок и продлений серверов по привлеченным клиентам указанного уровня",
  "Вознаграждение_info": "Общая сумма вашего партнерского вознаграждения, соответствующая уровню",

  "PARTNERS Network": "====================",
  "Партнерская_сеть": "Партнерская сеть",
  "Партнерская_сеть_info": "Ваша структура привлеченных клиентов",
  "Уровень": "Уровень",
  "Дата_регистрации": "Дата регистрации",

  "PARTNERS Promocodes": "====================",
  "Промокод_удален_успешно": "Промокод удален успешно",
  "Генератор_промокодов": "Генератор промокодов",
  "Генератор_промокодов_info": "Генератор промокодов позволяет сгенерировать партнеру промокод, по которому пользователь сможет получить скидку при аренде VPS на 1 месяц.",
  "Использовано": "Кол-во применений",

  "PARTNERS Modal Promocode": "====================",
  "Укажите_название_промокода": "Укажите название промокода",
  "Выберите_скидку": "Выберите скидку",
  "Код_успешно_создан": "Промокод успешно создан и готов к использованию!",
  "Cоздать_промокод": "Cоздать промокод",
  "Название_промокода": "Название промокода",
  "Размер_скидки": "Размер скидки",
  "Доступный_размер_скидки_зависит": "Доступный размер скидки зависит от количества привлеченных активных клиентов (подробнее в FAQ)",

  "OPERATIONS PAGE": "====================",
  "Балансовые": "Балансовые",
  "операции": "операции",
  "Ваш_баланс": "Ваш баланс",

  "OPERATIONS Deposit": "====================",
  "Пополнить_баланс": "Пополнить баланс",
  "Введите_сумму_пополнить": "Введите сумму, на которую желаете пополнить",
  "Сумма_пополнения": "Сумма пополнения",
  "Пополнить": "Пополнить",
  "Пополнение_баланса_личного_кабинета": "Пополнение баланса личного кабинета позволит вам воспользоваться функцией автопродления. Это означает, что продление аренды VPS будут автоматически оплачены с баланса вашего лицевого счета.",

  "OPERATIONS Modal Deposit": "====================",
  "Укажите_метод_пополнения": "Укажите метод пополнения",
  "Пополнение_баланса": "Пополнение баланса",
  "Метод_пополнения": "Метод пополнения",

  "OPERATIONS Transfer": "====================",
  "Произошла_ошибка_при_переводе": "Произошла ошибка при переводе. Повторите позже",
  "Перевод_между_счетами": "Перевод между счетами",
  "Введите_сумму_перевода": "Введите сумму перевода и адрес электронной почты получателя",
  "Недостаточный_баланс": "Недостаточно средств для совершения перевода",
  "Email_не_существует": "E-mail не существует",
  "Сумма_перевода": "Сумма перевода",
  "Email_получателя": "E-mail получателя",
  "Перевести": "Перевести",
  "Перевод_средств_позволит": "Перевод средств позволит вам отправить средства со своего баланса личного кабинета на баланс личного кабинета другого пользователя, зарегистрированного в системе.",

  "OPERATIONS Modal Transfer Success": "====================",
  "Заявка_на_перевод_создана": "Заявка на перевод выполнена успешно, средства переведены указанному клиенту",

  "OPERATIONS Filter": "====================",
  "История_пополнений": "Балансовые платежи",
  "История_переводов": "Переводы средств",
  "История_платежей": "Платежи по серверам",
  "История_выводов": "Выводы партнерки",
  "История_пополнений_инфо": "История платежей пополнения баланса личного кабинета",
  "История_переводов_инфо": "История переводов средств между аккаунтами",
  "История_платежей_инфо": "История платежей покупок и продления VPS серверов",
  "История_выводов_инфо": "История выводов партнерского вознаграждения",

  "OPERATIONS Transactions": "====================",

  "Получен": "Получен",
  "Отправлен": "Отправлен",

  "На_рассмотрении": "На рассмотрении",
  "Выплачен": "Выплачен",
  "Отменен": "Отменен",

  "Оплачен": "Оплачен",
  "Не_оплачен": "Не оплачен",
  "В_обработке": "В обработке",
  "Отклонен": "Отклонен",

  "Платежа": "Платежа",
  "Сервер": "Сервер",
  "Платежная_система": "Платежная система",
  "Дата": "Дата",

  "Cумма": "Cумма",
  "Удален": "Удален",

  "SUPPORT PAGE": "====================",

  "SUPPORT Create ticket": "====================",
  "Вопросы_по_VPS": "Вопросы по VPS",
  "Вопросы_по_Партнерке": "Вопросы по Партнерcкой программе",
  "Вопросы_по_платежам": "Вопросы по платежам",
  "Другие_вопросы": "Другие вопросы",
  "Файл_успешно_добавлен": "Файл успешно добавлен",
  "Поддерживаемые_форматы": "Поддерживаемые форматы: jpeg, gif, png, pdf",
  "Максимальный_размер_файла": "Максимальный размер: 5 МБ",
  "Файл_успешно_удален": "Файл успешно удален",
  "Выберите_раздел": "Выберите раздел",
  "Введите_заголовок_вопроса": "Введите заголовок вопроса",
  "Введите_текст_вопроса": "Введите текст вопроса",
  "Максимальное_количество_символов": "Максимальное количество символов 1024",
  "Создать_тикет": "Создать тикет",
  "Заголовок_вопроса": "Заголовок вопроса",
  "Текст_вопроса": "Текст вопроса",
  "Загрузить_файл": "Загрузить файл",
  "Отправить": "Отправить",
  "у_вас_имеется_открытый_тикет": "Уважаемый клиент, в текущем разделе у Вас имеется открытый тикет. Возможность открыть новый тикет в данном разделе станет доступна после закрытия текущего вопроса. Вы можете продолжить диалог в открытом тикете.",

  "SUPPORT Tickets list": "====================",
  "Новый": "Новый",
  "Закрыт": "Закрыт",
  "Рассмотрение": "Рассмотрение",
  "Тикеты": "Тикеты",
  "Заголовок": "Заголовок",

  "TICKET PAGE": "====================",
  "Тикет": "Тикет",
  "Создан": "Создан",
  "Файлы": "Файлы",

  "TICKET Dialog": "====================",
  "Тикет_был_закрыт": "Тикет был закрыт. Если хотите возобновить обсуждение, напишите сообщение",
  "Закрыть_тикет": "Закрыть тикет",
  "Введите_текст_сообщения": "Введите текст сообщения",
  "Введите_сообщение": "Введите сообщение",
  "Имя_файла": "Имя файла",

  "PROFILE PAGE": "====================",
  "Профиль": "Профиль",
  "Сохранить": "Сохранить",

  "Profile Change Avatar": "====================",
  "Размер_файла_превышает_1": "Размер файла превышает 1 Мб",
  "Фото_успешно_удалено": "Фото успешно удалено",
  "Произошла_ошибка_при_удалении_фото": "Произошла ошибка при удалении фото",
  "Cменить_фото": "Cменить фото",
  "Загрузить": "Загрузить",
  "Максимальный_размер_фото": "Максимальный размер фото до 1 мб",

  "Profile Change Password": "====================",
  "Для_изменения_пароля": "Для изменения пароля введите старый пароль",
  "Личная_информация": "Личная информация",
  "Сменить_пароль": "Сменить пароль",
  "Имя": "Имя",
  "Старый_пароль": "Старый пароль",
  "Повторить_новый_пароль": "Повторить новый пароль",
  "Пароль_изменен": "Пароль обновлен успешно",
  "Ошибка_при_измененении_пароля": "Произошла ошибка при обновлении пароля",

  "Profile Telegram Bot": "====================",
  "Телеграм_бот": "Телеграм бот",
  "Подключить": "Подключить",
  "Отписаться": "Отписаться",
  "Успешно_отключен": "Успешно отключен",
  "Подключив_Telegram_bot_вы_сможете": "Подключив Telegram bot вы сможете получать уведомления о приближающемся окончании срока аренды подключенных услуг и своевременно продлить их",

  "FAQ PAGE": "====================",
  "Быстрый_поиск_ответа": "Быстрый поиск ответа",
  "Задать_вопрос_службе_поддержки": "Задать вопрос службе поддержки",
  "Поиск": "Поиск",

  "": ""
}
